module.exports = __webpack_public_path__ + "static/media/share.e22a9e08.svg";